import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Brand } from "../types";

export const getBrandsList = async (): Promise<Brand[]> => {
  const collectionRef = collection(db, "brands");

  const q = query(collectionRef, orderBy("order", "asc"));

  const brandsSnapshot = await getDocs(q);

  return brandsSnapshot.docs
    .map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.name,
        mobilePortalId: data.mobilePortalId,
        desktopPortalId: data.desktopPortalId,
        order: data.order,
        createdAt: data.createdAt.toDate(),
        updatedAt: data.updatedAt.toDate(),
        isBrandMaintenanceMode: data.isBrandMaintenanceMode,
        brandMaintenanceModeDescription: data.brandMaintenanceModeDescription,
      };
    })
    .filter((brand) => brand.id !== "korean");
};
